import { useMutation, useQueryClient } from 'react-query';
import listedkitService from 'resources/listedkit/listedkit.service';
import uiNotifications from 'services/uiNotification.service';


export default function useCreateListedKit() {
  const queryClient = useQueryClient();

  return useMutation(
    (listedKit) => listedkitService.createListedKit(listedKit),
    {
      onSuccess: (response) => {
        if (!response || response.isBadRequest) {
          return;
        }

        uiNotifications.showSuccess('Transaction Kit was created');

        queryClient.invalidateQueries(['listedKits.getByCompanyId', response?.company_id]);
        queryClient.invalidateQueries(['milestones.getAllKitsMilestonesWithTasks', response?.company_id]);
        queryClient.invalidateQueries(['audits.getAllKitsAudits', response?.company_id]);
      },
      onError: (error) => {
        uiNotifications.showError('An error occurred while creating the Transaction Kit');
      },
    });
}
